/* =========================================================================
   PRESENTE AUTOMÁTICO NO CARRINHO

   Coloca o presente quando o carrinho passa do mínimo e tira quando desce.
   Nunca "brinde": a palavra é PRESENTE.

   QUEM DECIDE É O LIQUID, NÃO ESTE ARQUIVO.
   O snippet tp-presente.liquid publica, dentro da gaveta do carrinho, um
   JSON com `elegivel` e `temPresente` já calculados. Este arquivo só olha se
   os dois batem e executa a diferença. A conta mora lá porque depende de
   `compare_at_price`, que o /cart.js não devolve — o corte olha o valor
   ORIGINAL das peças e ignora o desconto.

   COMO O CICLO FECHA
   A gaveta é re-renderizada a cada mudança do carrinho, então o JSON se
   atualiza sozinho e este arquivo é chamado de novo. Depois de agir uma vez,
   o estado passa a bater e ele para. Não há laço.

   AS TRÊS TRAVAS, todas por acidente que aconteceria sem elas:

   1. `ocupado` — sem isso, dois eventos de carrinho quase simultâneos
      disparariam duas adições e a cliente levaria dois presentes.

   2. `recusado` (sessionStorage) — se a cliente apagar o presente na
      lixeira, nós o recolocaríamos no mesmo segundo e ela ficaria clicando
      sem conseguir tirar. Depois de recusar, só volta a entrar se o carrinho
      cair abaixo do mínimo e subir de novo — aí é um evento novo.

   3. `falhou` — se a adição der erro (presente esgotado, por exemplo), não
      insistir. Sem isso, cada mexida no carrinho viraria uma requisição
      falha e uma mensagem de erro.
   ========================================================================= */

(function () {
  if (window.__tpPresente) return;
  window.__tpPresente = true;

  /* NECESSAIRE -> PRESENTE COM TAMANHO (21/10/2026, a necessaire acabou). Quem ganhou a
     roleta antes da troca guardou o handle da Necessaire, e como a campanha seguiu a mesma
     (site-v1) ela continuava entrando no carrinho. Aqui o premio antigo vira o novo: handle,
     valor e rotulo trocados, variante/tamanho apagados -- sem variante, a regra da roleta tira
     a Necessaire que estiver no carrinho e pede o tamanho quando o pedido bate o minimo.
     Roda antes do tp-roleta.js (este script vem na gaveta, acima do rodape), entao a roleta ja
     nasce com o premio novo (aba, botao de tamanho, cartao "adicione mais").
     Vale tambem para o resultado do giro (tp-roleta-<campanha>) e o pendente sem e-mail. */
  (function migrarNecessaire() {
    var DE = 'presente-misterioso', PARA = 'presente-misterioso-roleta', VALOR = 18990;
    try {
      if (localStorage.getItem('tp-roleta-presente') === DE) {
        localStorage.setItem('tp-roleta-presente', PARA);
        localStorage.setItem('tp-roleta-presente-valor', String(VALOR));
        localStorage.removeItem('tp-roleta-presente-variante');
        localStorage.removeItem('tp-roleta-presente-tamanho');
      }
      for (var i = localStorage.length - 1; i >= 0; i--) {
        var k = localStorage.key(i);
        if (!k || k.indexOf('tp-roleta-') !== 0 || k.indexOf('tp-roleta-presente') === 0) continue;
        var g = null;
        try { g = JSON.parse(localStorage.getItem(k)); } catch (e) { continue; }
        if (!g || g.presente !== DE) continue;
        g.presente = PARA;
        g.presenteSemTamanho = false;
        g.presenteVariante = 0;
        g.presenteValor = VALOR;
        if ('prize' in g) g.prize = 'PRESENTE DE R$ 189,90';
        if ('label' in g) g.label = 'PRESENTE DE R$ 189,90';
        g.desc = 'Um presente misterioso de R$ 189,90 vai junto em compras a partir de R$ 399';
        localStorage.setItem(k, JSON.stringify(g));
      }
    } catch (e) {}
  })();

  /* UMA TRAVA POR REGRA, não uma global.

     São presentes independentes: um entra por VALOR do carrinho, outro por um
     PRODUTO estar nele. Com estado compartilhado, recusar um calaria o outro, e
     uma falha de estoque num desligaria os dois.

     `ultimoTem` e `nossaRemocao` também são por regra — é o par que reconhece
     que foi a cliente quem tirou aquele presente específico. */
  var porRegra = {};

  function trilho(nome) {
    if (!porRegra[nome]) {
      porRegra[nome] = {
        ocupado: false,
        falhou: false,
        ultimoTem: null,
        nossaRemocao: false,
        chaveRecusa: 'tp-presente-recusado-' + nome
      };
    }
    return porRegra[nome];
  }

  function lerEstado() {
    var el = document.querySelector('[data-tp-presente]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      console.error('[tp-presente] JSON de estado inválido', e);
      return null;
    }
  }

  function recusado(chave) {
    try { return sessionStorage.getItem(chave) === '1'; } catch (e) { return false; }
  }

  function marcarRecusa(chave, valor) {
    try {
      if (valor) sessionStorage.setItem(chave, '1');
      else sessionStorage.removeItem(chave);
    } catch (e) { /* navegação privada: sem memória, tudo bem */ }
  }

  function gaveta() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  // Pede as seções junto para o carrinho se redesenhar na mesma viagem.
  function corpoComSecoes(base) {
    var c = gaveta();
    if (c && typeof c.getSectionsToRender === 'function') {
      base.sections = c.getSectionsToRender().map(function (s) { return s.id; });
      base.sections_url = window.location.pathname;
    }
    return base;
  }

  function redesenhar(res) {
    var c = gaveta();
    if (c && typeof c.renderContents === 'function') {
      if (c.classList.contains('is-empty')) c.classList.remove('is-empty');
      c.renderContents(res);
    }
  }

  function pedir(url, corpo) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(corpo)
    }).then(function (r) { return r.json(); });
  }

  function adicionar(regra) {
    return pedir('/cart/add.js', corpoComSecoes({
      items: [{ id: regra.variantId, quantity: 1 }]
    })).then(function (res) {
      if (res && res.status) throw new Error(res.description || res.message || 'falha ao adicionar');
      redesenhar(res);
    });
  }

  // /cart/change.js por `id` de linha aceita a chave do item, que é o que o
  // Liquid nos deu. Quantidade 0 remove.
  function ajustar(chave, quantidade) {
    return pedir('/cart/change.js', corpoComSecoes({
      id: chave,
      quantity: quantidade
    })).then(function (res) {
      if (res && res.status) throw new Error(res.description || res.message || 'falha ao ajustar');
      redesenhar(res);
    });
  }

  /* PRESENÇA DO PRESENTE VEM DO /cart.js, NÃO DO HTML RENDERIZADO.

     Motivo, custou duas rodadas para eu enxergar: a renderização da gaveta
     pode estar ATRASADA em relação ao carrinho de verdade. Quando a cliente
     adiciona uma peça, a resposta do /cart/add.js já traz a gaveta desenhada —
     e ela foi gerada ANTES de nós colocarmos o presente. Aquele HTML diz
     "sem presente" mesmo com o presente no carrinho.

     Isso envenenava duas decisões: a detecção de recusa lia o atraso como "a
     cliente removeu" (e o presente parava de entrar de vez), e a adição
     tentaria colocar um segundo presente.

     Do estado do Liquid continuam vindo só `valorBase` e `elegivel`, que
     dependem de `compare_at_price` e não têm como ser calculados aqui. Um
     atraso nesses dois só adia o presente até o próximo redesenho — não
     produz carrinho errado. */
  /* UMA LEITURA DO /cart.js POR CONFERÊNCIA (01/10/2026). Antes cada regra e a
     roleta liam o carrinho por conta própria: 5 leituras a cada conferência.
     Agora `conferir` lê uma vez e passa adiante; só relê se alguma regra mexeu
     no carrinho no meio do caminho. */
  function lerCarrinho() {
    return fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); });
  }

  /* Id da variante quando o produto de presente tem UMA so; null se tiver tamanhos ou falhar. */
  var vuCache = {};
  async function varianteUnica(handle) {
    if (!handle) return null;
    if (handle in vuCache) return vuCache[handle];
    try {
      var p = await (await fetch('/products/' + encodeURIComponent(handle) + '.js')).json();
      var vs = p.variants || [];
      vuCache[handle] = (vs.length === 1) ? vs[0].id : null;
    } catch (e) { vuCache[handle] = null; }
    return vuCache[handle];
  }

  /* SKUs com estoque na peca de verdade do presente com tamanho (a regata original,
     o mesmo `estoque_handle` do pop-up de tamanho). Igual ao tp-rgg-presente.js. */
  async function skusComEstoque() {
    try {
      var p = await (await fetch('/products/blusa-slim-modeladora.js', { cache: 'no-store' })).json();
      var s = {};
      (p.variants || []).forEach(function (x) { if (x.available && x.sku) s[x.sku] = true; });
      return s;
    } catch (e) { return null; }
  }
  function sortearMesmoTamanho(vs, tamanho, est) {
    var pool = (vs || []).filter(function (x) { return x.option1 === tamanho && x.available && x.sku && est[x.sku]; });
    return pool.length ? pool[Math.floor(Math.random() * pool.length)] : null;
  }
  function esquecerTamanho() {
    try { localStorage.removeItem('tp-roleta-presente-variante'); localStorage.removeItem('tp-roleta-presente-tamanho'); } catch (e) {}
  }
  function comTamanho() {
    try { return localStorage.getItem('tp-roleta-presente-tamanho') !== 'unico'; } catch (e) { return false; }
  }

  function temLinhaRoleta(c) {
    return (c && c.items || []).some(function (i) { return i.properties && i.properties._roleta; });
  }

  function presencaReal(c, variantId) {
    /* LINHA COM `_roleta` E DE OUTRA REGRA (o premio da roleta), e por isso
       esta regra nao a enxerga -- quem cuida dela e `conferirPresenteRoleta`,
       logo abaixo, com as travas dela.

       Pular aqui NAO e deixar a linha sem dono: ja foi, e o resultado foi um
       pedido de R$ 0,00 com tres Necessaires. Pular so faz sentido porque
       existe o outro guarda. */
    var achado = null;
    var deOutroDono = false;
    (c.items || []).forEach(function (i) {
      if (String(i.variant_id) !== String(variantId)) return;
      if (i.properties && i.properties._roleta) {
        /* MESMO PRODUTO, OUTRO DONO -- e o que gerava duas Necessaires.
           A roleta e a regra de valor apontam para o mesmo
           `settings.presente_handle`. Continuamos nao GERENCIANDO a linha da
           roleta (ela tem as travas dela), mas precisamos SABER que ela
           existe: sem isso esta regra olhava, nao via nada, e somava a
           segunda quando o carrinho passava do minimo. */
        deOutroDono = true;
        return;
      }
      achado = i;
    });
    return {
      tem: !!achado,
      quantidade: achado ? achado.quantity : 0,
      chave: achado ? achado.key : '',
      deOutroDono: deOutroDono
    };
  }


  /* O PRESENTE DA ROLETA: acompanha compra, nunca sozinho, nunca mais de um.

     A roleta so GRAVA o handle em `tp-roleta-presente` quando a cliente ganha.
     Quem poe e tira e este guarda, e ele mora aqui porque este arquivo roda no
     site inteiro (vive na gaveta do carrinho) -- o JS da roleta so existe na
     pagina da colecao, entao policiar la deixaria o resto do site descoberto.

     AS TRES REGRAS, e a segunda e a que conserta o furo:
     1. ganhou e tem peca PAGA no carrinho  -> exatamente 1 presente;
     2. nao ha peca paga                    -> nenhum presente (era possivel
        fechar pedido de R$ 0,00 so com a Necessaire gratis);
     3. sobrou mais de uma linha ou quantidade > 1 -> volta para 1.

     "Peca paga" e linha sem `_roleta` com preco final > 0: presente de outra
     regra tambem custa zero e nao pode servir de acompanhante. */
  /* Ids da colecao gire-e-ganhe (e filhos dos biquinis), publicados por snippets/tp-rgg-dados. */
  function temPecaGireEGanhe(itens) {
    var el = document.querySelector('[data-tp-rgg-dados]');
    if (!el) return false;
    var ids = {};
    try { (JSON.parse(el.textContent).ids || []).forEach(function (id) { if (id) ids[String(id)] = true; }); } catch (e) { return false; }
    return (itens || []).some(function (x) { return ids[String(x.product_id)]; });
  }

  async function conferirPresenteRoleta(c) {
    var mexeu = false;
    var handle = null;
    try { handle = localStorage.getItem('tp-roleta-presente'); } catch (e) {}

    /* CAMPANHA ATUAL (24/09/2026): o presente so vale se foi ganho na campanha
       em vigor (snippet tp-roleta-campanha, publicado em `roletaCampanha`). O
       tp-roleta.js faz a mesma limpeza, mas so na pagina da roleta; quem nao
       voltava la continuava com o presente antigo entrando no carrinho. Aqui
       vale em qualquer pagina, e as chaves velhas sao apagadas de vez. */
    try {
      var estadoR = lerEstado();
      var campanhaAtual = estadoR && estadoR.roletaCampanha;
      var campanhaGravada = localStorage.getItem('tp-roleta-presente-campanha');
      if (handle && campanhaAtual && campanhaGravada !== campanhaAtual) {
        ['tp-roleta-presente', 'tp-roleta-presente-minimo', 'tp-roleta-presente-variante', 'tp-roleta-presente-tamanho', 'tp-roleta-presente-campanha', 'tp-roleta-presente-valor'].forEach(function (k) { localStorage.removeItem(k); });
        handle = null;
      }
    } catch (e) {}

    var t = trilho('roleta');
    if (t.ocupado) return false;
    t.ocupado = true;
    try {
      var itens = c.items || [];
      var nossas = itens.filter(function (x) { return x.properties && x.properties._roleta; });
      /* SO PECAS DA COLECAO DA ROLETA (25/09/2026): `roletaIds` vem do
         tp-presente.liquid -- produtos da gire-e-ganhe e filhos dos biquinis.
         Peca de outra colecao nao acompanha o presente nem soma para o
         minimo. Sem a lista (estado ilegivel), nao mexe em nada: melhor que
         tirar o presente de quem tem direito. */
      var estadoIds = lerEstado();
      if (!estadoIds || !Array.isArray(estadoIds.roletaIds)) return false;
      var daRoleta = {};
      estadoIds.roletaIds.forEach(function (id) { if (id) daRoleta[String(id)] = true; });
      /* 1 HORA DE DESCONTOS (28/10/2026, Guilherme): "o presente nao e ganho com produtos da
         1 hora de desconto" -- as copias da campanha (titulo "... - 1 Hora de Descontos") nao
         acompanham o presente nem somam para o minimo. So com elas no carrinho, o presente sai. */
      var pagas = itens.filter(function (x) {
        if (/1 Hora de Descontos/i.test(x.product_title || '')) return false;
        return !(x.properties && x.properties._roleta) && x.final_line_price > 0 && (estadoIds.roletaTodas || daRoleta[String(x.product_id)]);
      });

      /* GIRE E GANHE (20/10/2026, pedido do Guilherme): com QUALQUER peca da colecao
         gire-e-ganhe no carrinho, o presente desta roleta (a do site, Necessaire) nao
         entra de forma alguma -- e sai se ja estiver la. Os dois cartoes dele tambem
         somem. A Gire e Ganhe tem roleta e presente proprios (tp-roleta-gg /
         tp-rgg-presente.js); a lista de ids vem do snippet tp-rgg-dados (theme.liquid). */
      if (temPecaGireEGanhe(itens)) {
        faltamAtualizar({ handle: null, minimo: 0, totalPagas: 0, temPagas: false, url: '', itens: itens });
        emailCardAtualizar({ handle: null, totalPagas: 0, temPagas: false, itens: itens });
        for (var gg = 0; gg < nossas.length; gg++) { await ajustar(nossas[gg].key, 0); mexeu = true; }
        return mexeu;
      }

      /* MINIMO DA ROLETA (23/09/2026): a roleta grava, junto com o handle, quanto
         o pedido precisa ter em pecas pagas (centavos) para o presente entrar --
         "presente misterioso a partir de R$ 299". Abaixo disso vale a mesma regra
         de "sem peca paga": nenhum presente, e o que estiver no carrinho sai. */
      var minimo = 0;
      try { minimo = parseInt(localStorage.getItem('tp-roleta-presente-minimo') || '0', 10) || 0; } catch (e) {}
      var totalPagas = pagas.reduce(function (soma, x) { return soma + (x.final_line_price || 0); }, 0);
      /* PRECO COM DESCONTO (03/11/2026, Guilherme: "o presente ta se baseando no preco original ...
         colocou cupom -> abaixo de 399 com desconto -> presente deve sair"). O final_line_price ja
         desconta o cupom de PRODUTO (BLACK25), mas o de PEDIDO (AVISEME10, influs...) vem a parte em
         cart_level_discount_applications e nao tocava nas linhas: LipBailarina 449,90 com 10% (R$ 404,91)
         ou 20% (R$ 359,92) seguia com o presente. Sai a parte dele que cabe as pecas pagas. */
      var descPedido = (c.cart_level_discount_applications || []).reduce(function (soma, d) { return soma + (d.total_allocated_amount || d.amount || 0); }, 0);
      if (descPedido > 0 && c.items_subtotal_price > 0) {
        totalPagas -= Math.round(descPedido * Math.min(1, totalPagas / c.items_subtotal_price));
      }

      /* CARTAO "ADICIONE MAIS R$ X" (05/10/2026): com presente ganho e pecas da colecao
         abaixo do minimo, sobe o lembrete; acima (ou sem pecas), some. */
      faltamAtualizar({ handle: handle, minimo: minimo, totalPagas: totalPagas, temPagas: pagas.length > 0, url: estadoIds.roletaUrl || '', itens: itens });
      /* CARTAO "DEIXE SEU E-MAIL" (06/10/2026): girou, saiu sem o e-mail (tp-roleta-pendente
         gravado pela roleta) e o carrinho ja bate o minimo do presente -- lembra que so falta
         o e-mail. Sem handle, porque com o presente liberado quem fala e o cartao de cima. */
      emailCardAtualizar({ handle: handle, totalPagas: totalPagas, temPagas: pagas.length > 0, itens: itens });

      if (!pagas.length || totalPagas < minimo) {
        /* Abaixo do minimo: rearma o pedido de tamanho, para a proxima passagem pelo minimo perguntar de novo (22/10/2026). */
        if (window.tpPresenteTamanho && window.tpPresenteTamanho.rearmar) window.tpPresenteTamanho.rearmar();
        for (var r = 0; r < nossas.length; r++) { await ajustar(nossas[r].key, 0); mexeu = true; }
        return mexeu;
      }
      /* Sem vitoria valida gravada, nenhuma linha `_roleta` pode ficar: e o caso do
         presente da campanha anterior que ja estava no carrinho. */
      if (!handle) {
        for (var h = 0; h < nossas.length; h++) { await ajustar(nossas[h].key, 0); mexeu = true; }
        return mexeu;
      }

      /* TAMANHO ESCOLHIDO? (24/09/2026)
         O presente da roleta passou a ter tamanho (e cor sortida): a cliente
         escolhe no pop-up "Selecione o tamanho do seu presente misterioso", e a
         variante exata fica em `tp-roleta-presente-variante`. Sem isso gravado,
         nada entra -- e, como o carrinho JA passou do minimo (o `return` acima
         cuidou do contrario), e a hora de pedir o tamanho, em qualquer pagina.
         Uma vez por carregamento, para nao perseguir quem fechou. */
      var varianteEscolhida = null;
      try { varianteEscolhida = localStorage.getItem('tp-roleta-presente-variante'); } catch (e) {}
      if (!varianteEscolhida) {
        /* PRESENTE DE VARIANTE UNICA (05/10/2026): nao ha tamanho a escolher -- usa a
           variante do produto e grava, sem pop-up. So abre o pop-up de tamanho quando o
           produto tem mais de uma variante (a regata de setembro). */
        var unica = await varianteUnica(handle);
        if (unica) {
          try { localStorage.setItem('tp-roleta-presente-variante', String(unica)); localStorage.setItem('tp-roleta-presente-tamanho', 'unico'); } catch (e) {}
          varianteEscolhida = String(unica);
        } else {
          for (var q = 0; q < nossas.length; q++) { await ajustar(nossas[q].key, 0); mexeu = true; }
          if (window.tpPresenteTamanho) window.tpPresenteTamanho.pedir();
          return mexeu;
        }
      }

      if (!nossas.length) {
        if (t.falhou) return false;
        try {
          var prod = await (await fetch('/products/' + encodeURIComponent(handle) + '.js')).json();
          var vs = prod.variants || [];
          var v = null;
          /* A variante que a cliente escolheu (tamanho) e o sorteio deu (cor). So
             cai na primeira disponivel se ela tiver sumido de um presente de
             variante unica; com tamanho, cair na primeira trocava o tamanho (G
             virava P) -- entao esquece a escolha e pede o tamanho de novo. */
          for (var k = 0; k < vs.length; k++) { if (String(vs[k].id) === String(varianteEscolhida) && vs[k].available) { v = vs[k]; break; } }
          if (!v && vs.length > 1) { esquecerTamanho(); if (window.tpPresenteTamanho) window.tpPresenteTamanho.abrir(); return false; }
          if (!v) { for (k = 0; k < vs.length; k++) { if (vs[k].available) { v = vs[k]; break; } } }
          if (!v) return false;
          /* ESTOQUE NA PECA DE VERDADE (03/11/2026, Guilherme: "acabou o G de todos os
             tamanhos do presente ... quem ja selecionou consegue levar? nao e pra
             conseguir"). O pop-up so deixa escolher tamanho com estoque na regata, mas a
             escolha fica gravada e o produto de presente nao rastreia estoque: quem
             escolheu G antes de acabar seguia levando G. Agora a cor sorteada passa pelo
             estoque da regata na hora de entrar; esgotada, sorteia outra cor do MESMO
             tamanho; tamanho inteiro esgotado, nao entra e o pop-up pede outro tamanho
             (o G aparece desativado). Sem resposta da loja, segue como estava. */
          if (vs.length > 1) {
            var est = await skusComEstoque();
            if (est && !(v.sku && est[v.sku])) {
              var novo = sortearMesmoTamanho(vs, v.option1, est);
              if (!novo) { esquecerTamanho(); if (window.tpPresenteTamanho) window.tpPresenteTamanho.abrir(); return false; }
              v = novo;
              try { localStorage.setItem('tp-roleta-presente-variante', String(novo.id)); } catch (e) {}
            }
          }
          /* So entra de graca: se o produto deixar de custar zero um dia, o
             presente para de entrar em vez de virar cobranca surpresa. */
          if (v.price !== 0) return false;
          /* O OUTRO LADO DA MESMA TRAVA: a Necessaire pode ja estar no carrinho
             pela regra de valor (mesmo `settings.presente_handle`). Um presente
             so -- o direito da cliente esta atendido, e nao importa por qual
             regra ele entrou. Sem isto, ganhar na roleta DEPOIS de passar do
             minimo somava a segunda. */
          var jaTem = false;
          var idsDoProduto = vs.map(function (x) { return String(x.id); });
          (itens || []).forEach(function (i) {
            if (i.properties && i.properties._roleta) return;
            if (idsDoProduto.indexOf(String(i.variant_id)) !== -1) jaTem = true;
          });
          if (jaTem) return false;
          var res = await pedir('/cart/add.js', corpoComSecoes({
            items: [{ id: v.id, quantity: 1, properties: { _roleta: '1' } }]
          }));
          redesenhar(res);
          mexeu = true;
        } catch (err) {
          console.error('[tp-presente] nao deu para colocar o presente da roleta', err);
          t.falhou = true;
        }
        return mexeu;
      }

      for (var j = 1; j < nossas.length; j++) { await ajustar(nossas[j].key, 0); mexeu = true; }
      if (nossas[0].quantity > 1) { await ajustar(nossas[0].key, 1); mexeu = true; }
      /* O PRESENTE JA NO CARRINHO COM COR QUE ESGOTOU (03/11/2026): sai, e a proxima
         conferencia poe outra cor do mesmo tamanho (ou pede outro tamanho). */
      if (comTamanho()) {
        var estL = await skusComEstoque();
        if (estL && !(nossas[0].sku && estL[nossas[0].sku])) {
          try {
            var prodL = await (await fetch('/products/' + encodeURIComponent(handle) + '.js')).json();
            var atual = (prodL.variants || []).filter(function (x) { return String(x.id) === String(nossas[0].variant_id); })[0];
            var trocaL = atual ? sortearMesmoTamanho(prodL.variants || [], atual.option1, estL) : null;
            if (trocaL) { try { localStorage.setItem('tp-roleta-presente-variante', String(trocaL.id)); } catch (e) {} }
            else esquecerTamanho();
          } catch (e) { esquecerTamanho(); }
          await ajustar(nossas[0].key, 0);
          mexeu = true;
        }
      }
    } catch (e) {
      /* Silencioso: um erro aqui nao pode impedir as outras regras de presente. */
    } finally {
      t.ocupado = false;
    }
    return mexeu;
  }

  /* =====================================================================
     A OFERTA PRINCIPAL DA PAGINA MANDA (08/10/2026, pedido do Guilherme: "sempre que
     tiver 2 pop-ups pra aparecer no mesmo lugar, preferencia pro da oferta principal").

     Os cartoes da roleta deste arquivo (faltam R$ X / deixe seu e-mail) ficam de fora:
     (1) enquanto um cartao de oferta esta aberto (os cartoes avisam pelo evento
         tp-oferta-cartao: progressivo, Flash Promo, Data Dupla);
     (2) nas paginas das campanhas que tem cartao proprio na gaveta;
     (3) com peca dessas campanhas no carrinho (pelo handle; o progressivo tambem pelo
         estado data-tp-prog, que cobre os filhos de kit).
     ===================================================================== */
  var CAMPANHAS_COM_CARTAO = [
    { paginas: /\/collections\/(desconto-progressivo-exclusivo|promo-das-influs-1)(\/|$)|-(desconto-progressivo-exclusivo|progressivo-influs)$/, handles: /-(desconto-progressivo-exclusivo|progressivo-influs)$/ },
    { paginas: /\/collections\/flash-promo(\/|$)|\/products\/top-basic-flash-promo$/, handles: /^top-basic-flash-promo$/ },
    { paginas: /\/collections\/data-dupla(\/|$)|-data-dupla$/, handles: /-data-dupla$/ },
    /* Black Antecipada (20/10/2026): cartão único da gaveta (tp-black.js). 22/10/2026: a campanha passou a valer
       nos produtos da produtos-site-base (as duplicatas viraram rascunho), ou seja, no site todo: o cartão da
       Black manda em qualquer página e com qualquer peça no carrinho; os cartões da roleta deste arquivo ficam de fora. */
    { paginas: /./, handles: /./ },
    { paginas: /\/collections\/flash-liplegging(\/|$)|\/products\/liplegging-flash-promo$/, handles: /^liplegging-flash-promo$/ },
    { paginas: /\/collections\/bazar(\/|$)|-bazar(-\d+)?$/, handles: /-bazar(-\d+)?$/ },
    /* Moda Praia 2026 (13/10/2026): cartão da Bolsa de Praia na gaveta (tp-praia-bolsa.js) */
    { paginas: /\/collections\/lancamento-moda-praia(\/|$)|\/products\/(biquini-sustentacao|maio-sustentacao|calcinha-biquini-sustentacao|top-biquini-alca-fina|top-biquini-alta-sustentacao)$/, handles: /^(biquini-sustentacao|maio-sustentacao|calcinha-biquini-sustentacao|top-biquini-alca-fina|top-biquini-alta-sustentacao)$/ }
  ];
  var ofertaAberta = false;
  document.addEventListener('tp-oferta-cartao', function (ev) {
    ofertaAberta = !!(ev.detail && ev.detail.aberto);
    if (ofertaAberta) { flFechar(); emFechar(); }
  });
  function ofertaManda(itens) {
    if (ofertaAberta || document.querySelector('.tp-prog.is-aberto, .tp-fpl.is-aberto, .tp-ddc.is-aberto, .tp-flc.is-aberto, .tp-bzc.is-aberto, .tp-pbc.is-aberto, .tp-pcc.is-aberto, .tp-bkc.is-aberto')) return true;
    var aqui = (location.pathname || '').toLowerCase();
    var handles = (itens || []).map(function (x) { return String(x.handle || '').toLowerCase(); });
    if (CAMPANHAS_COM_CARTAO.some(function (c) { return c.paginas.test(aqui) || handles.some(function (h) { return c.handles.test(h); }); })) return true;
    try {
      var progEl = document.querySelector('[data-tp-prog]');
      var prog = progEl ? JSON.parse(progEl.textContent) : null;
      if (prog && (prog.campanhas || []).some(function (c) { return c.qtd > 0; })) return true;
    } catch (e) {}
    return false;
  }

  /* =====================================================================
     CARTAO "ADICIONE MAIS R$ X E GANHE O PRESENTE MISTERIOSO" (05/10/2026)

     Desenho do lembrete do Fecha Mes (tp-fm2): cartao escuro no rodape da
     tela, por cima da gaveta, sem escurecer nada. Sobe quando a cliente
     girou (handle gravado), tem peca da colecao da roleta no carrinho e a
     soma delas ainda nao bate o minimo. Some quando bate, quando o carrinho
     esvazia ou no "Nao, obrigada" -- que cala ate a soma mudar.

     Montado aqui em JS (sem Liquid): a gaveta redesenha o proprio markup a
     cada mudanca, e um cartao no Liquid dela viraria duas copias.
     ===================================================================== */
  var flRaiz = null, flTotal = null;
  function brl(c) { return 'R$\u00A0' + (c / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  /* A COLEÇÃO DE ONDE A CLIENTE VEIO (09/10/2026, Guilherme: os botões "Ver as peças" /
     "Continuar comprando" "deveriam sempre enviar pra página de coleção de onde a cliente
     veio"; "todos-os-produtos" nunca). Toda página /collections/<handle> grava o handle na
     sessão; os botões usam isso e, sem nada gravado, caem em produtos-site-base. As
     coleções "todos-os-produtos" / "all" não contam. */
  var COLECAO_PADRAO = '/collections/produtos-site-base';
  (function lembrarColecao() {
    var m = /^\/collections\/([^\/?#]+)/.exec(location.pathname);
    if (!m) return;
    var h = m[1];
    if (h === 'all' || h === 'todos-os-produtos') return;
    try { sessionStorage.setItem('tp-ultima-colecao', '/collections/' + h); } catch (e) {}
  })();
  function ultimaColecao(padrao) {
    var u = '';
    try { u = sessionStorage.getItem('tp-ultima-colecao') || ''; } catch (e) {}
    if (/\/collections\/(all|todos-os-produtos)(\/|$)/.test(u)) u = '';
    if (/\/collections\/(all|todos-os-produtos)(\/|$)/.test(padrao || '')) padrao = '';
    return u || padrao || COLECAO_PADRAO;
  }
  function flMontar() {
    if (flRaiz) return flRaiz;
    var css = document.createElement('style');
    css.textContent = '.tp-pfaltam{position:fixed;z-index:2147483000;left:50%;bottom:16px;width:min(100% - 24px,380px);transform:translate(-50%,16px);opacity:0;display:flex;align-items:flex-start;gap:12px;padding:14px 16px 14px 14px;border-radius:16px;background:#222F28;color:#F1F0EB;box-shadow:0 10px 30px rgba(34,47,40,.28);font-family:var(--tp-body-font,"Host Grotesk",ui-sans-serif,system-ui,sans-serif);transition:opacity .22s ease,transform .22s ease}'
      + '.tp-pfaltam[hidden]{display:none}.tp-pfaltam.is-aberto{opacity:1;transform:translate(-50%,0)}'
      /* desktop: canto inferior direito (no celular fica centralizado embaixo, como o tp-fm2) */
      + '@media (min-width:750px){.tp-pfaltam{left:auto;right:20px;bottom:20px;transform:translateY(16px)}.tp-pfaltam.is-aberto{transform:translateY(0)}}'
      + '.tp-pfaltam__icone{flex:0 0 auto;width:38px;height:38px;border-radius:12px;background:rgba(255,170,153,.18);color:#FFAA99;display:inline-flex;align-items:center;justify-content:center}.tp-pfaltam__icone svg{width:20px;height:20px}'
      + '.tp-pfaltam__corpo{flex:1 1 auto;min-width:0}.tp-pfaltam__eyebrow{margin:0 0 2px;font-size:1.05rem;letter-spacing:.1em;text-transform:uppercase;color:#FFAA99;font-weight:600}'
      + '.tp-pfaltam__titulo{margin:0 0 4px;font-size:1.45rem;line-height:1.3;font-weight:600}.tp-pfaltam__titulo b{color:#FFAA99;font-weight:700}'
      + '.tp-pfaltam__texto{margin:0 0 10px;font-size:1.2rem;line-height:1.4;color:rgba(241,240,235,.78)}'
      + '.tp-pfaltam__acoes{display:flex;align-items:center;gap:14px;flex-wrap:wrap}'
      + '.tp-pfaltam__sim{display:inline-flex;align-items:center;padding:9px 14px;border-radius:999px;background:#FFAA99;color:#222F28;font-size:1.25rem;font-weight:700;text-decoration:none}'
      + '.tp-pfaltam__nao{border:0;background:transparent;padding:6px 2px;color:rgba(241,240,235,.75);font:inherit;font-size:1.2rem;text-decoration:underline;text-underline-offset:3px;cursor:pointer}';
    document.head.appendChild(css);
    var el = document.createElement('div');
    el.className = 'tp-pfaltam';
    el.setAttribute('role', 'status');
    el.hidden = true;
    el.innerHTML = '<span class="tp-pfaltam__icone" aria-hidden="true"><svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M2.9 9.4h14.2v7.2a1 1 0 0 1-1 1H3.9a1 1 0 0 1-1-1V9.4z"/><path d="M2.1 6.6h15.8v2.8H2.1z"/><path d="M10 6.6v11"/><path d="M10 6.6S8.9 2.5 6.8 2.5a1.9 1.9 0 0 0 0 4.1H10z"/><path d="M10 6.6s1.1-4.1 3.2-4.1a1.9 1.9 0 0 1 0 4.1H10z"/></svg></span>'
      + '<div class="tp-pfaltam__corpo"><p class="tp-pfaltam__eyebrow">Presente surpresa</p><p class="tp-pfaltam__titulo" data-pf-titulo></p><p class="tp-pfaltam__texto">Ele entra no carrinho sozinho, por nossa conta.</p>'
      + '<div class="tp-pfaltam__acoes"><a class="tp-pfaltam__sim" data-pf-sim href="#">Ver as peças</a><button type="button" class="tp-pfaltam__nao" data-pf-nao>Não, obrigada</button></div></div>';
    document.body.appendChild(el);
    /* RESPONDEU = SILENCIO DE 30 MINUTOS (05/10/2026, pedido do Guilherme): "Ver as pecas" ou
       "Nao, obrigada" fecham o cartao e ele nao volta antes disso, em pagina nenhuma -- antes
       o "Ver as pecas" levava para a colecao e o cartao reaparecia la na hora. */
    function flSilenciar() { try { localStorage.setItem('tp-pfaltam-silencio', String(Date.now() + 30 * 60 * 1000)); } catch (e) {} }
    el.querySelector('[data-pf-nao]').addEventListener('click', function () { flSilenciar(); flFechar(); });
    el.querySelector('[data-pf-sim]').addEventListener('click', function () { flSilenciar(); flFechar(); });
    /* No desktop a gaveta abre pela direita: o cartao se encosta a esquerda dela para nao
       cobrir o botao de finalizar; fechou a gaveta, volta ao canto. */
    var cd = document.querySelector('cart-drawer');
    if (cd && window.MutationObserver) new MutationObserver(function () { setTimeout(flPosicionar, 350); }).observe(cd, { attributes: true, attributeFilter: ['class'] });
    window.addEventListener('resize', flPosicionar);
    flRaiz = el;
    return el;
  }
  function flPosicionar() {
    if (!flRaiz) return;
    if (window.innerWidth < 750) { flRaiz.style.right = ''; return; }
    var cd = document.querySelector('cart-drawer.active, cart-drawer[open]');
    var painel = cd && (cd.querySelector('[class*="drawer__inner"]') || cd.firstElementChild);
    var r = painel && painel.getBoundingClientRect();
    flRaiz.style.right = (r && r.width > 0 && r.width < window.innerWidth - 100) ? (window.innerWidth - r.left + 16) + 'px' : '';
  }
  function flFechar() {
    if (!flRaiz || flRaiz.hidden) return;
    flRaiz.classList.remove('is-aberto');
    var el = flRaiz;
    setTimeout(function () { if (!el.classList.contains('is-aberto')) el.hidden = true; }, 240);
  }
  function faltamAtualizar(info) {
    var mostrar = !!(info.handle && info.minimo > 0 && info.temPagas && info.totalPagas < info.minimo);
    if (!mostrar) { flFechar(); return; }
    var silencio = 0;
    try { silencio = parseInt(localStorage.getItem('tp-pfaltam-silencio') || '0', 10) || 0; } catch (e) {}
    if (Date.now() < silencio) return;
    /* Com a roleta ou o pop-up do presente abertos, espera: a proxima mexida no carrinho
       chama de novo. Dois avisos ao mesmo tempo seria barulho. */
    var html = document.documentElement;
    if (html.classList.contains('tp-roleta-open') || html.classList.contains('tp-pg-open') || html.classList.contains('tp-pt-open') || html.classList.contains('tp-pe-open')) return;
    /* A OFERTA PRINCIPAL DA PAGINA MANDA (08/10/2026): ver ofertaManda. */
    if (ofertaManda(info.itens)) { flFechar(); return; }
    var valor = 0;
    try { valor = parseInt(localStorage.getItem('tp-roleta-presente-valor') || '0', 10) || 0; } catch (e) {}
    var el = flMontar();
    flTotal = info.totalPagas;
    el.querySelector('[data-pf-titulo]').innerHTML = 'Adicione mais <b>' + brl(info.minimo - info.totalPagas) + '</b> e ganhe o presente surpresa' + (valor > 0 ? ' de ' + brl(valor) : '');
    var sim = el.querySelector('[data-pf-sim]');
    sim.href = ultimaColecao(info.url); sim.hidden = false;
    if (el.hidden) { el.hidden = false; void el.offsetWidth; }
    el.classList.add('is-aberto');
    flPosicionar();
  }

  /* =====================================================================
     CARTAO "DEIXE SEU E-MAIL E GANHE O PRESENTE MISTERIOSO" (06/10/2026)

     Mesmo desenho do cartao de cima (classes .tp-pfaltam). Sobe quando a
     cliente girou, saiu do pedido de e-mail sem preencher (a roleta grava
     tp-roleta-pendente com o premio) e as pecas pagas do carrinho ja batem
     o minimo do presente. "Deixar meu e-mail" pede a roleta para reabrir o
     pop-up do e-mail (evento tp-roleta-pedir-email: a liberacao do presente
     mora la); "Nao, obrigada" cala por 30 minutos. Some quando o e-mail e
     dado, o presente e liberado ou o carrinho cai abaixo do minimo.
     ===================================================================== */
  var emRaiz = null;
  function emPendente() { try { var p = JSON.parse(localStorage.getItem('tp-roleta-pendente') || 'null'); return p && p.presente ? p : null; } catch (e) { return null; } }
  function emMontar() {
    if (emRaiz) return emRaiz;
    flMontar(); /* injeta o CSS compartilhado */
    var css = document.createElement('style');
    css.textContent = '.tp-pfaltam--email .tp-pfaltam__sim{border:0;font:inherit;cursor:pointer}';
    document.head.appendChild(css);
    var el = document.createElement('div');
    el.className = 'tp-pfaltam tp-pfaltam--email';
    el.setAttribute('role', 'status');
    el.hidden = true;
    el.innerHTML = '<span class="tp-pfaltam__icone" aria-hidden="true"><svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><rect x="2.5" y="4.5" width="15" height="11" rx="2"/><path d="M3 5.5l7 5.5 7-5.5"/></svg></span>'
      + '<div class="tp-pfaltam__corpo"><p class="tp-pfaltam__eyebrow">Presente surpresa</p><p class="tp-pfaltam__titulo" data-em-titulo></p><p class="tp-pfaltam__texto" data-em-texto></p>'
      + '<div class="tp-pfaltam__acoes"><button type="button" class="tp-pfaltam__sim" data-em-sim>Deixar meu e-mail</button><button type="button" class="tp-pfaltam__nao" data-em-nao>Não, obrigada</button></div></div>';
    document.body.appendChild(el);
    function emSilenciar() { try { localStorage.setItem('tp-pemail-silencio', String(Date.now() + 30 * 60 * 1000)); } catch (e) {} }
    el.querySelector('[data-em-nao]').addEventListener('click', function () { emSilenciar(); emFechar(); });
    el.querySelector('[data-em-sim]').addEventListener('click', function () {
      emFechar();
      try { document.dispatchEvent(new CustomEvent('tp-roleta-pedir-email')); } catch (e) {}
    });
    var cd = document.querySelector('cart-drawer');
    if (cd && window.MutationObserver) new MutationObserver(function () { setTimeout(emPosicionar, 350); }).observe(cd, { attributes: true, attributeFilter: ['class'] });
    window.addEventListener('resize', emPosicionar);
    emRaiz = el;
    return el;
  }
  function emPosicionar() {
    if (!emRaiz) return;
    if (window.innerWidth < 750) { emRaiz.style.right = ''; return; }
    var cd = document.querySelector('cart-drawer.active, cart-drawer[open]');
    var painel = cd && (cd.querySelector('[class*="drawer__inner"]') || cd.firstElementChild);
    var r = painel && painel.getBoundingClientRect();
    emRaiz.style.right = (r && r.width > 0 && r.width < window.innerWidth - 100) ? (window.innerWidth - r.left + 16) + 'px' : '';
  }
  function emFechar() {
    if (!emRaiz || emRaiz.hidden) return;
    emRaiz.classList.remove('is-aberto');
    var el = emRaiz;
    setTimeout(function () { if (!el.classList.contains('is-aberto')) el.hidden = true; }, 240);
  }
  function emailCardAtualizar(info) {
    var p = emPendente();
    var emailDado = false;
    try { emailDado = !!localStorage.getItem('tp-roleta-email'); } catch (e) {}
    var minimo = p ? Math.round((+p.presenteMinimo || 0) * 100) : 0;
    var mostrar = !!(p && !info.handle && !emailDado && info.temPagas && info.totalPagas >= minimo);
    if (!mostrar) { emFechar(); return; }
    var silencio = 0;
    try { silencio = parseInt(localStorage.getItem('tp-pemail-silencio') || '0', 10) || 0; } catch (e) {}
    if (Date.now() < silencio) return;
    var html = document.documentElement;
    if (html.classList.contains('tp-roleta-open') || html.classList.contains('tp-pg-open') || html.classList.contains('tp-pt-open') || html.classList.contains('tp-pe-open')) return;
    /* A OFERTA PRINCIPAL DA PAGINA MANDA (08/10/2026): ver ofertaManda. */
    if (ofertaManda(info.itens)) { emFechar(); return; }
    var valor = parseInt(p.presenteValor, 10) || 0;
    var el = emMontar();
    el.querySelector('[data-em-titulo]').innerHTML = 'Deixe seu e-mail e ganhe o presente surpresa' + (valor > 0 ? ' de <b>' + brl(valor) + '</b>' : '');
    el.querySelector('[data-em-texto]').textContent = (minimo > 0 ? 'Seu pedido já passou de ' + brl(minimo) + ': ' : '') + 'só falta o e-mail para ele entrar no carrinho, por nossa conta.';
    if (el.hidden) { el.hidden = false; void el.offsetWidth; }
    el.classList.add('is-aberto');
    emPosicionar();
  }

  /* =====================================================================
     POP-UP "PRESENTE GANHO" (05/10/2026) -- presente SEM tamanho.

     Markup em sections/tp-presente-ganho.liquid, buscado pela Section
     Rendering API so quando a roleta termina (tp-roleta.js chama
     window.tpPresenteGanho.abrir(premio)). Troca [valor] e [minimo] pelos
     numeros do premio; `extraDelay` ms depois de abrir, liga a classe
     is-extra e o FRETE GRATIS entra com a animacao do CSS (clarao, selo,
     faiscas, brilho) -- as faiscas sao criadas aqui, com angulos sorteados.
     ===================================================================== */
  var pgRaiz = null, pgDados = null, pgCarregando = null, pgTimer = null;
  function pgCarregar() {
    if (pgRaiz) return Promise.resolve(pgRaiz);
    if (pgCarregando) return pgCarregando;
    pgCarregando = fetch(ptRoot() + '?section_id=tp-presente-ganho', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var raiz = doc.querySelector('[data-tp-presente-ganho]');
        var dados = doc.querySelector('[data-tp-presente-ganho-dados]');
        var estilo = doc.querySelector('style');
        if (!raiz || !dados) throw new Error('secao tp-presente-ganho sem markup');
        pgDados = JSON.parse(dados.textContent);
        if (estilo) document.head.appendChild(document.importNode(estilo, true));
        pgRaiz = document.importNode(raiz, true);
        document.body.appendChild(pgRaiz);
        pgRaiz.addEventListener('click', function (ev) {
          if (!ev.target.closest('[data-pg-fechar]')) return;
          /* "Continuar comprando" NA HOME leva para a vitrine (produtos-site-base): na home
             nao ha o que comprar na propria pagina. Em qualquer outra pagina (PDP, colecao,
             carrinho...) so fecha e a cliente segue onde estava. X, overlay e ESC sempre
             so fecham. Pedido do Guilherme, 06/10/2026. */
          if (ev.target.closest('.tp-pg__ok') && /^\/(index)?\/?$/.test(location.pathname)) { pgFechar(); location.href = ultimaColecao(); return; }
          pgFechar();
        });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && pgRaiz && !pgRaiz.hidden) pgFechar(); });
        return pgRaiz;
      })
      .catch(function (e) { console.error('[tp-presente] pop-up do presente ganho', e); pgCarregando = null; throw e; });
    return pgCarregando;
  }
  function pgTexto(modelo, premio) {
    var minimo = Math.round((+premio.presenteMinimo || 0) * 100);
    return String(modelo || '')
      .replace(/\[valor\]/g, premio.presenteValor > 0 ? brl(premio.presenteValor).replace(/,00$/, '') : 'surpresa')
      .replace(/\[minimo\]/g, minimo > 0 ? brl(minimo).replace(/,00$/, '') : 'qualquer valor');
  }
  function pgAbrir(premio) {
    premio = premio || {};
    return pgCarregar().then(function (raiz) {
      raiz.querySelector('[data-pg-titulo]').innerHTML = pgTexto(pgDados.titulo, premio);
      raiz.querySelector('[data-pg-texto]').textContent = pgTexto(pgDados.texto, premio);
      var foto = raiz.querySelector('[data-pg-foto]');
      if (foto) {
        if (premio.presenteFoto) { foto.src = premio.presenteFoto; foto.alt = premio.presenteTitulo || ''; foto.hidden = false; }
        else foto.hidden = true;
      }
      var sparks = raiz.querySelector('[data-pg-sparks]');
      if (sparks) {
        sparks.innerHTML = '';
        for (var i = 0; i < 18; i++) {
          var s = document.createElement('i');
          s.style.setProperty('--ang', Math.round(i * (360 / 18) + (Math.random() * 14 - 7)) + 'deg');
          s.style.setProperty('--dist', Math.round(90 + Math.random() * 70) + 'px');
          s.style.setProperty('--delay', Math.round(160 + Math.random() * 220) + 'ms');
          sparks.appendChild(s);
        }
      }
      raiz.classList.remove('is-extra');
      var sheet = raiz.querySelector('.tp-pg__sheet');
      if (sheet) sheet.classList.remove('is-impacto');
      raiz.hidden = false;
      document.documentElement.classList.add('tp-pg-open');
      if (sheet) { sheet.scrollTop = 0; try { sheet.focus({ preventScroll: true }); } catch (e) {} }
      clearTimeout(pgTimer);
      var atraso = parseInt(pgDados.extraDelay, 10); if (isNaN(atraso)) atraso = 1500;
      pgTimer = setTimeout(function () {
        if (!pgRaiz || pgRaiz.hidden) return;
        pgRaiz.classList.add('is-extra');
        if (sheet) { void sheet.offsetWidth; sheet.classList.add('is-impacto'); }
        try { if (navigator.vibrate) navigator.vibrate([30, 40, 60]); } catch (e) {}
      }, atraso);
    }).catch(function () {});
  }
  function pgFechar() {
    if (!pgRaiz) return;
    clearTimeout(pgTimer);
    pgRaiz.hidden = true;
    document.documentElement.classList.remove('tp-pg-open');
    /* A roleta (ainda aberta por tras, com o resultado) escuta isto e fecha junto:
       pedido do Guilherme, 06/10/2026 -- fechou o pop-up do presente, acabou. */
    try { document.dispatchEvent(new CustomEvent('tp-pg-fechou')); } catch (e) {}
    /* O carrinho pode ja estar abaixo do minimo com peca da colecao: o cartao
       "adicione mais" estava esperando o pop-up fechar. */
    agendarConferencia();
  }
  window.tpPresenteGanho = { abrir: pgAbrir, fechar: pgFechar };

  /* =====================================================================
     POP-UP "DEIXE SEU E-MAIL" (06/10/2026) -- antes de liberar o presente.

     Markup em sections/tp-presente-email.liquid. A roleta chama
     window.tpPresenteEmail.abrir(premio) 2 s depois do resultado; a promessa
     so resolve quando o e-mail foi aceito -- e ai a roleta registra o presente
     e abre o pop-up "presente ganho". Fechar sem preencher nao resolve nada:
     o resultado fica na roleta e a aba "Veja seu premio" pede de novo.

     O e-mail vai para o Klaviyo pela API publica de inscricao (chave publica
     + lista da secao, $source "Captacao Roleta - Site"). Dado uma vez, fica em
     localStorage (tp-roleta-email) e nunca mais e pedido. Erro de rede ou do
     servidor NAO trava o presente (bloqueador de anuncios costuma barrar o
     Klaviyo): guardamos o e-mail e liberamos; so erro de validacao (4xx) volta
     para a cliente corrigir.
     ===================================================================== */
  var peRaiz = null, peDados = null, peCarregando = null, peResolver = null;
  function peDado() { try { return !!localStorage.getItem('tp-roleta-email'); } catch (e) { return false; } }
  function peCarregar() {
    if (peRaiz) return Promise.resolve(peRaiz);
    if (peCarregando) return peCarregando;
    peCarregando = fetch(ptRoot() + '?section_id=tp-presente-email', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var raiz = doc.querySelector('[data-tp-presente-email]');
        var dados = doc.querySelector('[data-tp-presente-email-dados]');
        var estilo = doc.querySelector('style');
        if (!raiz || !dados) throw new Error('secao tp-presente-email sem markup');
        peDados = JSON.parse(dados.textContent);
        if (estilo) document.head.appendChild(document.importNode(estilo, true));
        peRaiz = document.importNode(raiz, true);
        document.body.appendChild(peRaiz);
        peRaiz.addEventListener('click', function (ev) {
          if (ev.target.closest('[data-pe-fechar]')) peFechar();
          else if (ev.target.closest('[data-pe-voltar]')) { peConfirmando(false); try { peRaiz.querySelector('[data-pe-email]').focus({ preventScroll: true }); } catch (e) {} }
          else if (ev.target.closest('[data-pe-sair]')) peFechar('sair');
        });
        peRaiz.querySelector('[data-pe-form]').addEventListener('submit', peEnviar);
        peRaiz.querySelector('[data-pe-email]').addEventListener('input', function () { peErro(''); });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && peRaiz && !peRaiz.hidden) peFechar(); });
        return peRaiz;
      })
      .catch(function (e) { console.error('[tp-presente] pop-up do e-mail', e); peCarregando = null; throw e; });
    return peCarregando;
  }
  function peErro(msg) {
    if (!peRaiz) return;
    var el = peRaiz.querySelector('[data-pe-erro]');
    el.textContent = msg || '';
    el.hidden = !msg;
    peRaiz.classList.toggle('is-erro', !!msg);
  }
  function peAbrir(premio) {
    premio = premio || {};
    return peCarregar().then(function (raiz) {
      raiz.querySelector('[data-pe-titulo]').innerHTML = pgTexto(peDados.titulo, premio);
      raiz.querySelector('[data-pe-texto]').textContent = pgTexto(peDados.texto, premio);
      var sairTxt = raiz.querySelector('[data-pe-sair-texto]');
      if (sairTxt) sairTxt.innerHTML = pgTexto(peDados.sairTexto, premio);
      peConfirmando(false);
      var foto = raiz.querySelector('[data-pe-foto]');
      if (foto) {
        if (premio.presenteFoto) { foto.src = premio.presenteFoto; foto.alt = premio.presenteTitulo || ''; foto.hidden = false; }
        else foto.hidden = true;
      }
      peErro('');
      raiz.classList.remove('is-enviando');
      raiz.querySelector('[data-pe-ok]').disabled = false;
      emFechar(); /* o cartao "deixe seu e-mail" sai de cena enquanto o pop-up esta aberto */
      raiz.hidden = false;
      document.documentElement.classList.add('tp-pe-open');
      setTimeout(function () { try { raiz.querySelector('[data-pe-email]').focus({ preventScroll: true }); } catch (e) {} }, 350);
      return new Promise(function (resolve) { peResolver = resolve; });
    });
  }
  function peConfirmando(on) {
    if (!peRaiz) return;
    peRaiz.classList.toggle('is-confirmando', !!on);
    var bloco = peRaiz.querySelector('[data-pe-confirma]');
    if (bloco) bloco.hidden = !on;
  }
  /* QUER SAIR SEM O E-MAIL? (06/10/2026, Guilherme). X, fundo ou ESC trocam o formulario pelo
     aviso "se voce nao colocar seu e-mail, nao vai desbloquear seu presente"; "Deixar meu e-mail"
     volta; "Sair mesmo assim" fecha de verdade e avisa a roleta (tp-pe-saiu), que fecha junto e
     deixa a aba "Desbloquear seu premio". modo: undefined = tentativa (confirma antes),
     'sair' = fecha e avisa, 'ok' = e-mail aceito (fecha em silencio). */
  function peFechar(modo) {
    if (!peRaiz || peRaiz.hidden) return;
    if (!modo && !peRaiz.classList.contains('is-confirmando')) { peConfirmando(true); return; }
    peRaiz.hidden = true;
    document.documentElement.classList.remove('tp-pe-open');
    peConfirmando(false);
    if (modo !== 'ok') { try { document.dispatchEvent(new CustomEvent('tp-pe-saiu')); } catch (e) {} }
    /* Fechou (com ou sem e-mail): o carrinho pode ja bater o minimo -- os cartoes do rodape
       estavam esperando o pop-up sair. */
    agendarConferencia();
  }
  /* Uma inscricao = uma lista (a API publica nao aceita duas). */
  function peInscreverEm(email, listaId) {
    var d = peDados || {};
    var corpo = { data: { type: 'subscription', attributes: {
      custom_source: d.fonte || 'Roleta',
      profile: { data: { type: 'profile', attributes: { email: email } } }
    }, relationships: { list: { data: { type: 'list', id: listaId } } } } };
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(d.companyId), {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' }, body: JSON.stringify(corpo)
    });
  }
  /* DUAS LISTAS (07/10/2026, pedido do Guilherme): a da roleta ("Captacao Roleta - Site", para
     relatorio e segmentacao) e a "Welcome_site", que e a unica que dispara o flow Boas_Vindas_V1
     -- um flow so aceita uma lista como gatilho, e a lista da roleta nao dispara nenhum. A da
     roleta valida o e-mail (4xx = a cliente corrige); a do boas-vindas e melhor esforco: falhar
     ali nao pode travar o presente. */
  function peInscrever(email) {
    var d = peDados || {};
    if (!d.companyId || !d.listaId) return Promise.resolve();
    return peInscreverEm(email, d.listaId).then(function (r) {
      if (r.status >= 400 && r.status < 500) throw new Error('klaviyo ' + r.status);
      /* 2xx = aceito; 5xx = problema deles, nao da cliente: segue. */
    }, function () { /* rede/bloqueador: segue */ }).then(function () {
      if (!d.listaWelcome) return;
      return peInscreverEm(email, d.listaWelcome).then(function () {}, function () {});
    });
  }
  function peEnviar(ev) {
    ev.preventDefault();
    if (!peRaiz) return;
    var input = peRaiz.querySelector('[data-pe-email]'), btn = peRaiz.querySelector('[data-pe-ok]');
    var email = String(input.value || '').trim().toLowerCase();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { peErro(peDados.erroEmail || 'E-mail inválido.'); try { input.focus(); } catch (e) {} return; }
    peErro('');
    btn.disabled = true;
    peRaiz.classList.add('is-enviando');
    peInscrever(email).then(function () {
      try { localStorage.setItem('tp-roleta-email', email); } catch (e) {}
      try { if (window.klaviyo && typeof window.klaviyo.push === 'function') window.klaviyo.push(['identify', { $email: email }]); } catch (e) {}
      peFechar('ok');
      var r = peResolver; peResolver = null;
      if (r) r(email);
    }).catch(function () {
      btn.disabled = false;
      peRaiz.classList.remove('is-enviando');
      peErro(peDados.erroEnvio || 'Não foi possível enviar. Tente de novo.');
    });
  }
  function peAberto() { return !!(peRaiz && !peRaiz.hidden); }
  window.tpPresenteEmail = { abrir: peAbrir, fechar: function () { peFechar('ok'); }, dado: peDado, aberto: peAberto };

  /* UMA CONFERÊNCIA POR VEZ. Se o carrinho mudar no meio de uma (inclusive pelo
     presente que nós mesmos pusemos), roda mais UMA no fim, com o carrinho já
     assentado. Não vira laço: a de confirmação encontra o estado batendo. */
  var rodando = false, deNovo = false;

  async function conferir() {
    if (rodando) { deNovo = true; return; }
    rodando = true;
    try {
      var estado = lerEstado();
      if (!estado) return;

      var carrinho;
      try { carrinho = await lerCarrinho(); }
      catch (err) { console.error('[tp-presente]', err); return; } // a próxima mudança tenta de novo

      /* Uma versão anterior deste arquivo lia UM presente. A lista veio com o
         segundo (o do lançamento Bosque, que entra por produto e não por valor).
         Cada regra é conferida por conta própria: uma falhar não impede a outra. */
      /* A ROLETA VEM PRIMEIRO (05/10/2026): a regra 1 (Necessaire por valor) precisa ver a
         linha `_roleta` ja no carrinho para sair de cena -- ver conferirRegra. */
      if (await conferirPresenteRoleta(carrinho)) {
        try { carrinho = await lerCarrinho(); }
        catch (err) { console.error('[tp-presente]', err); return; }
      }

      var regras = estado.regras || [];
      /* Variantes das regras LIGADAS: uma regra desligada que aponte para a mesma variante
         (ex.: "produto" e "conjunto2", as duas na faixa Bosque) nao pode tirar o que a
         ligada acabou de por. Ver limparOrfao. */
      regrasAtivasIds = {};
      regras.forEach(function (r) { if (r && r.ativo && r.variantId) regrasAtivasIds[String(r.variantId)] = true; });
      for (var i = 0; i < regras.length; i++) {
        // Regra que mexeu no carrinho: a próxima precisa do carrinho novo.
        if (await conferirRegra(regras[i], carrinho)) {
          try { carrinho = await lerCarrinho(); }
          catch (err) { console.error('[tp-presente]', err); return; }
        }
      }

      await limparExPresentes(carrinho);

    } finally {
      rodando = false;
      if (deNovo) { deNovo = false; agendarConferencia(); }
    }
  }

  /* PRESENTE ORFAO (12/10/2026). Pedido #1238328: a cliente levou SO a Necessaire, R$ 0,00,
     frete gratis. Como: a regra 1 (Necessaire por valor) pos o presente no carrinho dela em
     setembro, quando estava ligada; a regra foi desligada (presente_ativo = false) e este
     arquivo, para regra desligada, simplesmente nao olhava o carrinho ("return"). A linha de
     R$ 0 ficou la por semanas; ela voltou por um anuncio, tirou/perdeu a peca paga e fechou o
     pedido com o presente sozinho. Mais 4 pedidos do dia 12/10 tinham a Necessaire pelo
     mesmo caminho.

     Agora: regra DESLIGADA que encontra a propria variante no carrinho, de graca e sem
     `_roleta` (a linha da roleta tem o guarda dela), TIRA a linha -- a menos que outra regra
     ligada use a mesma variante (regrasAtivasIds), caso em que a linha e dela. */
  var regrasAtivasIds = {};
  async function limparOrfao(e, carrinho) {
    if (regrasAtivasIds[String(e.variantId)]) return false;
    var real = presencaReal(carrinho, e.variantId);
    if (!real.tem || real.deOutroDono) return false;
    var linha = null;
    (carrinho.items || []).forEach(function (i) {
      if (String(i.variant_id) === String(e.variantId) && !(i.properties && i.properties._roleta)) linha = i;
    });
    if (!linha || (linha.final_line_price || 0) > 0) return false; /* so tira o que e de graca */
    try { await ajustar(real.chave, 0); return true; }
    catch (err) { console.error('[tp-presente] nao deu para tirar o presente orfao "' + e.nome + '"', err); return false; }
  }

  /* EX-PRESENTE (20/10/2026). Pedido #1240095: calcinha + top da Moda Praia com TRES brindes
     a R$ 0 -- Saquinho de Viagem, Bolsa de Praia e Protetor de Lavagem. Sao as tres versoes
     do brinde da regra 6 (saquinho em 15/10 de manha, bolsa ate 16/10, protetor desde entao):
     a cada troca de `presente6_handle` a regra passava a apontar para outra variante, e a
     anterior ficava no carrinho para sempre, porque limparOrfao so conhece a variante ATUAL
     de cada regra. Mais 11 pedidos levaram a bolsa ou o saquinho pelo mesmo caminho.

     Agora: linha de produto tipo "Brinde" a R$ 0 (preco do cadastro, nao desconto), sem
     `_roleta`, que NAO e a variante de nenhuma regra ligada, sai do carrinho. Nenhum outro
     arquivo do tema poe brinde no carrinho; o premio da roleta tem `_roleta` e o guarda dele. */
  async function limparExPresentes(carrinho) {
    var linhas = (carrinho && carrinho.items || []).filter(function (i) {
      if (i.properties && i.properties._roleta) return false;
      if (String(i.product_type || '').trim().toLowerCase() !== 'brinde') return false;
      if ((i.original_price || 0) > 0) return false;
      return !regrasAtivasIds[String(i.variant_id)];
    });
    for (var k = 0; k < linhas.length; k++) {
      try { await ajustar(linhas[k].key, 0); }
      catch (err) { console.error('[tp-presente] nao deu para tirar o ex-presente "' + linhas[k].title + '"', err); }
    }
  }

  // Devolve true quando adicionou ou ajustou alguma linha do carrinho.
  async function conferirRegra(e, carrinho) {
    if (!e || !e.variantId) return false;
    if (!e.ativo) return limparOrfao(e, carrinho);
    var t = trilho(e.nome);
    if (t.ocupado) return false;

    t.ocupado = true;
    var mexeu = false;
    try {
      var real = presencaReal(carrinho, e.variantId);

      /* A CLIENTE TIROU O PRESENTE?

         O presente estava no carrinho, saiu, o carrinho continua acima do
         mínimo, e não fomos nós que tiramos. Só a cliente pode ter feito isso.

         A primeira versão vigiava o clique na lixeira por seletor de DOM e
         falhou calada: o clique chega no `document` com alvo
         <cart-remove-button>, não no <button> que carrega a classe e o
         data-variant-id. A condição nunca era verdadeira e o presente voltava
         um segundo depois de a cliente apagá-lo. Comparar estado não depende
         de marcação nenhuma — nem da nossa, nem da do tema, nem da de um app. */
      if (t.ultimoTem === true && !real.tem && e.elegivel && !t.nossaRemocao) {
        marcarRecusa(t.chaveRecusa, true);
      }
      t.nossaRemocao = false;
      t.ultimoTem = real.tem;

      /* UM PRESENTE SO, DE NOVO (05/10/2026): o presente da roleta passou a ser a propria
         Necessaire (outro produto, mesmo SKU). Com uma linha `_roleta` no carrinho, a regra
         1 (por valor) nao poe a Necessaire automatica -- e, se ela ja estava la, tira. So
         muda a vida de quem girou a roleta; para o resto do site a regra 1 segue igual. */
      if (e.nome === 'valor' && temLinhaRoleta(carrinho)) {
        if (real.tem) { t.nossaRemocao = true; await ajustar(real.chave, 0); return true; }
        return false;
      }

      // Deixou de ser elegível: a recusa perde a validade. Se a cliente voltar a
      // cumprir a condição, é um evento novo e o presente entra de novo.
      if (!e.elegivel && recusado(t.chaveRecusa)) marcarRecusa(t.chaveRecusa, false);

      if (e.elegivel && !real.tem && !recusado(t.chaveRecusa)) {
        if (!e.disponivel || t.falhou) return; // esgotado ou já deu erro: não insistir
        /* UM PRESENTE, NAO DOIS. A cliente que ganhou a Necessaire na roleta e
           passou do minimo levava duas: a da roleta e a desta regra. O presente
           e o mesmo produto, entao o direito ja esta atendido -- esta regra sai
           de fininho e deixa a linha da roleta em paz.
           Se o carrinho cair abaixo do minimo depois, nada muda: o premio da
           roleta nao depende de valor e a linha continua sendo dela. */
        if (real.deOutroDono) return;
        try {
          await adicionar(e);
          mexeu = true;
        } catch (err) {
          console.error('[tp-presente] não deu para adicionar o presente "' + e.nome + '"', err);
          t.falhou = true;
        }
      } else if (!e.elegivel && real.tem) {
        t.nossaRemocao = true;
        mexeu = true;
        await ajustar(real.chave, 0);
      } else if (real.tem && real.quantidade > 1) {
        // Presente é um só. Se a quantidade subiu por qualquer caminho
        // (carrinho recuperado de outra sessão, gaveta em cache), volta para 1.
        mexeu = true;
        await ajustar(real.chave, 1);
      }
    } catch (err) {
      // Falha de rede ao mexer no carrinho não desliga o mecanismo: a
      // próxima mudança tenta de novo.
      console.error('[tp-presente]', err);
    } finally {
      t.ocupado = false;
    }
    return mexeu;
  }

  /* =====================================================================
     POP-UP "SELECIONE O TAMANHO DO SEU PRESENTE MISTERIOSO" (24/09/2026)

     O markup mora em sections/tp-presente-tamanho.liquid e so e buscado
     (Section Rendering API) quando alguem pede para abrir -- nenhuma pagina
     carrega a tabela de medidas a toa. Quem chama:
       - tp-roleta.js, logo depois do giro que da presente;
       - conferirPresenteRoleta acima, quando o carrinho passa do minimo e
         a cliente ainda nao escolheu (uma vez por carregamento).

     Ao confirmar: filtra as variantes do presente no tamanho escolhido cujo
     SKU esta disponivel na peca de verdade, sorteia uma, grava
     `tp-roleta-presente-variante` e `tp-roleta-presente-tamanho`, avisa a
     roleta (evento tp:presente-tamanho) e roda a conferencia do carrinho.
     ===================================================================== */
  var ptRaiz = null, ptDados = null, ptCarregando = null, ptPediu = false, ptTamanho = null;
  function ptRoot() { try { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; } catch (e) { return '/'; } }
  function ptCarregar() {
    if (ptRaiz) return Promise.resolve(ptRaiz);
    if (ptCarregando) return ptCarregando;
    ptCarregando = fetch(ptRoot() + '?section_id=tp-presente-tamanho', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var raiz = doc.querySelector('[data-tp-presente-tamanho]');
        var dados = doc.querySelector('[data-tp-presente-tamanho-dados]');
        var estilo = doc.querySelector('style');
        if (!raiz || !dados) throw new Error('secao tp-presente-tamanho sem markup');
        ptDados = JSON.parse(dados.textContent);
        if (estilo) document.head.appendChild(document.importNode(estilo, true));
        ptRaiz = document.importNode(raiz, true);
        document.body.appendChild(ptRaiz);
        ptLigar();
        return ptRaiz;
      })
      .catch(function (e) { console.error('[tp-presente] pop-up de tamanho', e); ptCarregando = null; throw e; });
    return ptCarregando;
  }
  function ptLigar() {
    var ok = ptRaiz.querySelector('[data-pt-confirmar]');
    var erro = ptRaiz.querySelector('[data-pt-erro]');
    ptRaiz.addEventListener('click', function (ev) {
      // Tabela de medidas: camada por cima do pop-up, com "Voltar"
      if (ev.target.closest('[data-pt-tabela-abrir]')) { ptTabela(true); return; }
      if (ev.target.closest('[data-pt-tabela-fechar]')) { ptTabela(false); return; }
      if (ev.target.closest('[data-pt-fechar]')) { ptFechar(); return; }
      var b = ev.target.closest('[data-pt-tam]');
      if (b && !b.disabled) {
        ptTamanho = b.getAttribute('data-pt-tam');
        [].forEach.call(ptRaiz.querySelectorAll('[data-pt-tam]'), function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        ok.disabled = false; ok.textContent = ptDados.botaoOk || 'Confirmar tamanho';
        erro.hidden = true;
      }
    });
    ok.addEventListener('click', function () {
      if (!ptTamanho) return;
      var doTamanho = ptDados.variantes.filter(function (v) { return v.tamanho === ptTamanho && v.available; });
      /* SORTEIO DA COR: entre as cores cujo SKU esta em estoque na peca de
         verdade. Se nenhuma estiver, vale qualquer uma do tamanho -- o pedido
         fecha e o estoque troca a cor no despacho, em vez de a cliente ficar
         sem o presente prometido. */
      var comEstoque = doTamanho.filter(function (v) { return v.sku && ptDados.estoque.indexOf(v.sku) > -1; });
      var pool = comEstoque.length ? comEstoque : doTamanho;
      if (!pool.length) { erro.textContent = 'Esse tamanho esgotou. Escolha outro.'; erro.hidden = false; return; }
      var sorteada = pool[Math.floor(Math.random() * pool.length)];
      try {
        localStorage.setItem('tp-roleta-presente-variante', String(sorteada.id));
        localStorage.setItem('tp-roleta-presente-tamanho', ptTamanho);
      } catch (e) {}
      ptFechar();
      try { document.dispatchEvent(new CustomEvent('tp:presente-tamanho', { detail: { tamanho: ptTamanho } })); } catch (e) {}
      agendarConferencia();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !ptRaiz || ptRaiz.hidden) return;
      var tab = ptRaiz.querySelector('[data-pt-tabela]');
      if (tab && !tab.hidden) ptTabela(false); else ptFechar();
    });
  }
  function ptTabela(abrir) {
    var tab = ptRaiz && ptRaiz.querySelector('[data-pt-tabela]');
    if (!tab) return;
    tab.hidden = !abrir;
    if (abrir) { var sh = tab.querySelector('.tp-pt__tabela-sheet'); if (sh) sh.scrollTop = 0; }
  }
  function ptAbrir() {
    // 1 Hora de Descontos (28/10/2026): sem pop-up nas paginas e carrinhos da campanha (snippets/tp-uma-hora-head).
    if (window.tpSemPop) return Promise.resolve(null);
    return ptCarregar().then(function (raiz) {
      // Tamanhos esgotados em todas as cores da peca de verdade ficam riscados
      [].forEach.call(raiz.querySelectorAll('[data-pt-tam]'), function (b) {
        var t = b.getAttribute('data-pt-tam');
        var tem = ptDados.variantes.some(function (v) { return v.tamanho === t && v.available && v.sku && ptDados.estoque.indexOf(v.sku) > -1; });
        b.disabled = !tem;
      });
      raiz.hidden = false;
      document.documentElement.classList.add('tp-pt-open');
      ptTabela(false);
      var sheet = raiz.querySelector('.tp-pt__sheet');
      if (sheet) { sheet.scrollTop = 0; try { sheet.focus({ preventScroll: true }); } catch (e) {} }
    }).catch(function () {});
  }
  function ptFechar() {
    if (!ptRaiz) return;
    ptRaiz.hidden = true;
    document.documentElement.classList.remove('tp-pt-open');
  }
  function ptEscolhido() { try { return localStorage.getItem('tp-roleta-presente-variante'); } catch (e) { return null; } }
  window.tpPresenteTamanho = {
    abrir: ptAbrir,
    preparar: ptCarregar, // só busca e monta (escondido); a roleta v2 chama ao abrir (21/10/2026)
    fechar: ptFechar,
    escolhido: ptEscolhido,
    // "pedir" = abrir uma vez por carregamento, e so se ainda nao escolheu
    pedir: function () { if (ptPediu || ptEscolhido()) return; ptPediu = true; ptAbrir(); },
    // "rearmar" = o proximo pedir() abre de novo. Chamado quando o carrinho cai abaixo do minimo (22/10/2026, Guilherme:
    // "quando o minimo for atingido, girou e nao escolheu tamanho, o pop-up aparece de novo") -- cada nova passagem
    // pelo minimo pergunta outra vez; dentro da mesma passagem continua uma vez so, para nao perseguir quem fechou.
    rearmar: function () { ptPediu = false; }
  };

  var agendado = null;
  function agendarConferencia() {
    clearTimeout(agendado);
    agendado = setTimeout(conferir, 80);
  }

  /* SÓ CONTA COMO MUDANÇA DO CARRINHO A TROCA DO NOSSO <script> DE ESTADO.

     A gaveta tem coisa viva dentro: o cronômetro "Termina em" troca os
     números a cada segundo, e outros snippets mexem no próprio markup. Com o
     observador reagindo a qualquer mutação, a conferência rodava todo
     segundo, em toda aba aberta, com 5 leituras do /cart.js cada (01/10/2026:
     ~5 pedidos por segundo por visitante, e o servidor começou a devolver 503).

     Todo redesenho da gaveta (que é o que acontece quando o carrinho muda)
     cria um [data-tp-presente] novo. Então: mesmo elemento e mesmo texto =
     nada mudou no carrinho, não confere. */
  var estadoVisto = null, textoVisto = null;
  function estadoMudou() {
    var el = document.querySelector('[data-tp-presente]');
    var txt = el ? el.textContent : null;
    if (el === estadoVisto && txt === textoVisto) return false;
    estadoVisto = el;
    textoVisto = txt;
    return true;
  }

  function iniciar() {
    estadoMudou();
    conferir();

    /* GATILHO PRINCIPAL: o redesenho da gaveta.

       Depender só de PUB_SUB_EVENTS.cartUpdate deixa buracos — nem todo
       caminho que mexe no carrinho publica o evento (o próprio
       renderContents chamado por outro código, por exemplo, não publica).
       O que SEMPRE acontece quando o carrinho muda é o innerHTML de
       #CartDrawer ser trocado, e junto com ele o nosso <script> de estado.
       Observar isso pega todos os caminhos, inclusive os que ainda não
       existem.

       Sem laço: depois de agirmos, o redesenho seguinte traz um estado que
       já bate, e o conferir() não encontra diferença para executar. */
    // #CartDrawer e não .drawer__inner: o próprio .drawer__inner é substituído
    // num dos caminhos, e um observador amarrado nele morreria junto.
    var raiz = document.getElementById('CartDrawer');
    if (raiz && window.MutationObserver) {
      new MutationObserver(function () {
        if (estadoMudou()) agendarConferencia();
      }).observe(raiz, { childList: true, subtree: true });
    }

    // Cinto e suspensório: o evento do tema continua valendo.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, agendarConferencia);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
